import { useEffect } from "react";
import { drawingStore } from "../store";
import { useSnapshot } from "valtio/react";

/**
 * @deprecated Unsafe, does not ensure a subscription is made as the store may
 * not yet exist. Use the useSubscriptionToDrawingReduxStore hook instead.
 */
export const subscribeToDrawingStore = (callback: () => void) => {
  const store = drawingStore.reduxStore?.store;
  if (!store) return;

  return store.subscribe(callback);
};

/**
 * Safely subscribe to change events on the redux drawing store from within the
 * context of React. This ensures that if the call to subscribe occurs before
 * the drawings store has been initialised then the subscription will still
 * work.
 */
export function useSubscriptionToDrawingReduxStore(subscription: () => void) {
  const { reduxStore } = useSnapshot(drawingStore);
  const storeInitialised = !!reduxStore;

  useEffect(() => {
    if (!reduxStore?.store) return;
    const unsubscribe = reduxStore.store.subscribe(subscription);
    return unsubscribe;

    // After any state change the redux store reference changes, we only want to
    // refire the subcsription side-effect if; the store goes from
    // uninitialised->initialised, or the subscription handler changes.

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeInitialised, subscription]);
}
